import React, { Component } from 'react';
import uuid from 'uuid/v4';
import styled from 'styled-components';
import { Screen, Tap } from 'dooh-react-utils';
import go from '../go.png';

const Wrapper = styled.div`
  width: 1080px;
  height: 1920px;
`

const H1 = styled.div`
  width: 919px;
  margin: 0 auto;
  padding: 130px 0 30px 0;
  color: white;
  font-size: 149px;
  font-family: "zabaBold";
`;

const H2 = styled.div`
  width: 919px;
  margin: 0 auto;
  padding: 10px 0 0 0;
  color: white;
  font-size: 103px;
  font-family: "zabaRegular";
  line-height: 96%;

  & b {
    font-family: zabaBold;
  }
`;

const IntroButton = styled.div`
  width: 500px;
  height: 500px;
  margin: 240px auto;
  background-image: url(${go});
  background-repeat: no-repeat;

  @keyframes pulse_animation {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  };

  animation-name: pulse_animation;
  animation-duration: 1200ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;


export default class IntroScreen extends Component {

  componentDidMount() {
    this.props.update(s => ({...s, session: null, game: null}));
  }

  render() {
    return (
      <Screen>
        <Tap onTap={this.start}>
          <Wrapper>
            <H1>Zaigraj i osvoji!</H1>
            <H2>Tko kaže da ne mogu<br/>uzeti <b>500kn</b> na brzinu.</H2>
            <IntroButton></IntroButton>
          </Wrapper>
        </Tap>
      </Screen>
    );
  }

  start = () => {
    this.props.gotoNextScreen();
    this.props.update(s => ({...s, session: uuid()}));
  }
}




// WEBPACK FOOTER //
// ./src/screens/IntroScreen.js